import React from 'react'
import {Container, Row, Col} from 'reactstrap'

const MessageList = props => {

  function select(sofId, from) {
    props.history.push(`/portal-message/${sofId}`)
  }

  return (
    <Container>
      {props.messages.map((item) => {
        const time = new Date()
        time.setTime(item.ts)
        return (
          <div key={item.companySOFId + item.ts} onClick={() => select(item.sofId, item.from)} style={{cursor: 'pointer'}}>
            <Row key={item.companySOFId + item.ts+'-2'}><Col>To: {item.to}</Col></Row>
            <Row key={item.companySOFId + item.ts+'-1'}><Col>From: {item.from}</Col></Row>
            <Row key={item.companySOFId + item.ts+'-3'}>
                <Col>Time: {time.toString()}</Col>
            </Row>

            <Row key={item.companySOFId + item.ts + '-4'}>
              <Col>
                <strong>{item.message}</strong>
              </Col>
            </Row>
            <div style={{height: '1em'}}/>
          </div>
        )
      })}
    </Container>
  )
}

export default MessageList

